import { ResolverTag } from '@ps/web-core-enums';
import { StarsButton, Translation, useNavigate, useResolver } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import styles from './../TournamentTicketsContent.scss';
import {
  TXTCLI_Download,
  TXTWCL_Browse_tournaments,
  TXTWCL_If_you_have_tickets_available__ELL,
  TXTWCL_To_view_all_of_your_ticketsX_p_ELL
} from './TournamentTicketsPokerContent.messages.json';

const TournamentTicketsPokerContent: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const downloadPageLink = useResolver(ResolverTag.PSDownloadPage);
  const tournamentTicketsLink = useResolver(ResolverTag.TournamentTicketsLobby);
  const navigate = useNavigate();
  const tournamentTicketsPath = tournamentTicketsLink
    ? new URL(tournamentTicketsLink).pathname.replace('//', '/')
    : '';
  const openMttLoby = () => {
    navigate(tournamentTicketsPath);
    modal.close();
  };

  return (
    <>
      <Translation tagName="p" {...TXTWCL_If_you_have_tickets_available__ELL} />
      <Translation tagName="p" {...TXTWCL_To_view_all_of_your_ticketsX_p_ELL} />
      <div className={styles.buttonContainer}>
        <StarsButton
          disabled={!tournamentTicketsPath}
          onClick={openMttLoby}
          translation={TXTWCL_Browse_tournaments}
        />
        <StarsButton
          variant="secondary"
          target="_blank"
          rel="noopener noreferrer"
          href={downloadPageLink}
          disabled={!downloadPageLink}
          translation={TXTCLI_Download}
        />
      </div>
    </>
  );
};

export default TournamentTicketsPokerContent;
